import { createStore, combineReducers, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import UbicacionApiReducer from './UbicacionApiDucks'

//APIS
import { CopomexReducer } from './DucksApis/CopomexDucks'

import { FC01ReducerBeneficiario } from './DucksBeneficiario/FC_01Ducks'
import { FC05ReducerBeneficiario } from './DucksBeneficiario/FC_05Ducks'
import { FC08ReducerBeneficiario } from './DucksBeneficiario/FC_08Ducks'
import { FC09ReducerBeneficiario } from './DucksBeneficiario/FC_09Ducks'
import { FC33ReducerBeneficiario } from './DucksBeneficiario/FC_33Ducks'
import { FC35ReducerBeneficiario } from './DucksBeneficiario/FC_35Ducks'
import { FC34ReducerBeneficiario } from './DucksBeneficiario/FC_34Ducks'
import { FC36ReducerBeneficiario } from './DucksBeneficiario/FC_36Ducks'
import { FC06ReducerBeneficiario } from './DucksBeneficiario/FC_06Ducks'
import { FC31ReducerBeneficiario } from './DucksBeneficiario/FC_31Ducks'
import { FC41ReducerBeneficiario } from './DucksBeneficiario/FC_41Ducks'
import { FC40ReducerBeneficiario } from './DucksBeneficiario/FC_40Ducks'
import { FC30ReducerBeneficiario } from './DucksBeneficiario/FC_30Ducks'
//importar atencion a cliente
import { FC01ReducerAtencionACliente } from './DucksAtencionACliente/FC_01AtencionAClienteDucks'
import { FC05ReducerAtencionACliente } from './DucksAtencionACliente/FC_05AtencionAClienteDucks'
import { FC08ReducerAtencionACliente } from './DucksAtencionACliente/FC_08AtencionAClienteDucks'
import { FC09ReducerAtencionACliente } from './DucksAtencionACliente/FC_09AtencionAClienteDucks'
import { FC33ReducerAtencionACliente } from './DucksAtencionACliente/FC_33AtencionAClienteDucks'
import { FC35ReducerAtencionACliente } from './DucksAtencionACliente/FC_35AtencionAClienteDucks'
import { FC34ReducerAtencionACliente } from './DucksAtencionACliente/FC_34AtencionAClienteDucks'
import { FC36ReducerAtencionACliente } from './DucksAtencionACliente/FC_36AtencionAClienteDucks'
import { FC06ReducerAtencionACliente } from './DucksAtencionACliente/FC_06AtencionAClienteDucks'
import { FC31ReducerAtencionACliente } from './DucksAtencionACliente/FC_31AtencionAClienteDucks'
import { FC41ReducerAtencionACliente } from './DucksAtencionACliente/FC_41AtencionAClienteDucks'
import { FC40ReducerAtencionACliente } from './DucksAtencionACliente/FC_40AtencionAClienteDucks'
import { FC30ReducerAtencionACliente } from './DucksAtencionACliente/FC_30AtencionAClienteDucks'
import { UsuariosAtencionAClienteReducer } from './DucksAtencionACliente/UsuariosAtencionAClienteDuck'
import { ModuloConsultaReducer } from './DucksAtencionACliente/ModuloConsultaDucks'

import AtencionClientesReducer from './DucksAtencionACliente/AtencionAClienteDucks'
import SolicitudesReducer from './SolicitudesDucks'
import usuarioReducer from './UsuarioDucks'
import { usuariosReducer } from './UsuariosDcuks'
import AppReducer from './AppDucks'
import autoMergeLevel1 from 'redux-persist/lib/stateReconciler/autoMergeLevel1'
import { SublocalidadReducer } from './DucksUnidadInspeccion/SublocalidadDuck'

//Inspector
import { CalendarioReducer } from './DucksUnidadInspeccion/CalendarioDuck'
import { InspectorReducer } from './DucksUnidadInspeccion/InspectoresDuck'
import { ZonaReducer } from './DucksUnidadInspeccion/ZonasDuck'
import { UnidadesReducer } from './DucksUnidadInspeccion/UnidadesDuck'
import { PuestoReducer } from './DucksUnidadInspeccion/PuestosDuck'
import { VehiculoReducer } from './DucksUnidadInspeccion/VehiculosDuck'
import { DiasDeAtencionReducer } from './DucksUnidadInspeccion/DiasDeAtencionDuck'
import { AsociadoReducer } from './DucksUnidadInspeccion/AsociadosDuck'
import { ClienteReducer } from './DucksBeneficiario/ClienteDucks'
import { InstalacionReducer } from './DucksUnidadInspeccion/InstalacionDuck'
import { CuestionarioReducer } from './DucksUnidadInspeccion/CuestionarioDuck'
import { CaratulaReducer } from './DucksUnidadInspeccion/CaratulaDuck'
import { BuenasPracticasReducer } from './DucksUnidadInspeccion/BuenasPracticasDuck'
import { TestigosReducer } from './DucksUnidadInspeccion/TestigosDuck'
import { ResponsablesReducer } from './DucksUnidadInspeccion/ResponsablesDuck'
import { InformeReducer } from './DucksUnidadInspeccion/InformeCumplimientoDuck'
import { SeccionCuestionarioReducer } from './DucksUnidadInspeccion/SeccionCuestionarioDuck'
import { PreguntaInstalacionReducer } from './DucksUnidadInspeccion/PreguntaInstalacionDuck'
import { CalificacionPreguntaReducer } from './DucksUnidadInspeccion/CalificacionPreguntaDuck'
import { DataElementoClienteHistorialReducer } from './DucksUnidadInspeccion/DataElementoClienteHistorialDuck'
import { EquipoHistorialReducer } from './DucksUnidadInspeccion/Fi25anexoEquipoHistorial'
import { TipoEquipoReducer } from './DucksUnidadInspeccion/TipoEquipoDuck'
import { ProcesoReducer } from './DucksUnidadInspeccion/ProcesosDuck'
import { anexoReducer } from './DucksUnidadInspeccion/Fi25anexoDuck'
import { FotoGaleriaReducer } from './DucksUnidadInspeccion/FotogaleriaDuck'
import { SuperficieReducer } from './DucksUnidadInspeccion/SuperficieDuck'
import { ElementoSeccionReducer } from './DucksUnidadInspeccion/ElementoSeccionDuck'
import { ArchivosReducer } from './DucksUnidadInspeccion/ArchivosDuck'
import { CumplimientoReducer } from './DucksUnidadInspeccion/CumplimientoNom070Duck'
import { SolicitudesUIF01Reducer } from './DucksUnidadInspeccion/SolicitudesUIF01Duck'
import { Fi25DocumentosReducer } from './DucksUnidadInspeccion/DocumentosDuck'
import { MesZonaReducer } from './DucksUnidadInspeccion/MesZonaDuck'
import { AsociadoLocalidadReducer } from './DucksUnidadInspeccion/AsociadosEnLaLocalidadDuck'
import { PeriodosReducer } from './DucksUnidadInspeccion/PeriodosDuck'
import { AnalisisFQReducer } from './DucksUnidadInspeccion/AnalisisFQDuck'
import { DocumentosLoteReducer } from './DucksUnidadInspeccion/DocumentosLoteDuck'
import { LaboratorioReducer } from './DucksUnidadInspeccion/LaboratorioDuck'
import { FoliosUIReducer } from './DucksUnidadInspeccion/FoliosUIDuck'

//REBECA
import { RebecaUIReducer } from './DucksUnidadInspeccion/RebeckaDuck'
import { TrazabilidadReducer } from './DucksUnidadInspeccion/TrazabilidadDuck'

import { CatalogoMagueyReducerUsuarioAgricola } from './DucksUsuarioAgricola/CatalogoMagueyDucks'
import { GuiaMagueyReducerUsuarioAgricola } from './DucksUsuarioAgricola/GuiaMagueyDucks'
import { RegistroPredioReducerUsuarioAgricola } from './DucksUsuarioAgricola/RegistroPredioDucks'
import { ConstanciasReducerUsuarioAgricola } from './DucksUsuarioAgricola/ConstanciaDucks'
import { PoligonoKmlReducerUsuarioAgricola } from './DucksUsuarioAgricola/PoligonoKmlDucks'
import { DatosPredioReducerUsuarioAgricola } from './DucksUsuarioAgricola/DatosPredioDucks'
import { DatosMagueyReducerUsuarioAgricola } from './DucksUsuarioAgricola/DatosMagueyDucks'
import { InformacionValidaReducer } from './InformacionValidaDucks'
import { DatosMagueyHistoricoReducerUsuarioAgricola } from './DucksUsuarioAgricola/DatosMagueyHistoricoDucks'
import { DatosPredioHistoricoReducerUsuarioAgricola } from './DucksUsuarioAgricola/DatosPredioHistoricoDucks'

import { CatalogoMagueyNombreCientificoReducer } from './DucksUsuarioAgricola/CatalogoNombreCientificoDucks'

//Duck Para Organismo de certificacion
import { EstatusSolicitudesUIF01Reducer } from './DuckOrganismoCertificacion/EstatusSolicitudesUIF01Duck'
import { OficiosBeneficiarioOCReducer } from './DuckOrganismoCertificacion/OficiosBeneficiarioOCDuck'
import { GenerarUsuariosReducer } from './DuckOrganismoCertificacion/GenerarUsuariosDuck'
import { SolicitudesFC01_OCReducer } from './DuckOrganismoCertificacion/SolicitudesFC01_OCDuck'
import { SolicitudesFC09_OCReducer } from './DuckOrganismoCertificacion/SolicitudesFC09_OCDuck'

// import { GenerarOficiosReducer } from './DuckOrganismoCertificacion/GenerarOficiosDuck'
// import { InformacionClienteReducer } from './DuckOrganismoCertificacion/InformacionClienteDuck'

//Duck para store de panel de hologramas
import { ModuloComprasReducer } from './DuckPanelHologramas/ModuloComprasDuck'
import { ModuloInventarioReducer } from './DuckPanelHologramas/ModuloInventarioDuck'
import { ModuloEntregasReducer } from './DuckPanelHologramas/ModuloEntregasDuck'

//Duck Division Agricola 
import { UsuarioDivisionAgricolaReducer } from './DucksUsuarioAgricola/UsuarioDivisionAgricolaDuck'

//Duck Direccion 
import { DireccionGerenteReducer } from './DuckDireccionGerente/DireccionGerenteDuck'

//Duck para Usuario developer 
import { UsuarioDeveloperReducer } from './DuckUsuarioDeveloper/SolicitudesDevDuck'
import { ConstanciasDevReducer } from './DuckUsuarioDeveloper/ConstanciasDevDuck'
import { DescuentoPredioReducerUsuarioAgricola } from './DucksUsuarioAgricola/DescuentoPredioDucks'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['Usuario', 'Usuarios', 'AppState'],
  /*blacklist: ['FC_01Solicitud', 'FC_05Solicitud', 'FC_08Solicitud', 'FC_09Solicitud', 'FC_33Solicitud'
    , 'FC_35Solicitud', 'FC_34Solicitud', 'FC_36Solicitud', 'FC_06Solicitud', 'FC_31Solicitud'
    , 'FC_41Solicitud', 'FC_30Solicitud', 'FC_40Solicitud', 'Solicitudes']*/
}
const persistConfigAtencionACliente = {
  key: 'root',
  storage,
  whitelist: ['Usuario', 'Usuarios', 'AppState'],
  /*blacklist: [
    'FC_01SolicitudAtencionACliente', 'FC_05SolicitudAtencionACliente', 'FC_08SolicitudAtencionACliente',
    'FC_09SolicitudAtencionACliente', 'FC_33SolicitudAtencionACliente', 'FC_35SolicitudAtencionACliente',
    'FC_34SolicitudAtencionACliente', 'FC_36SolicitudAtencionACliente', 'FC_06SolicitudAtencionACliente',
    'FC_31SolicitudAtencionACliente', 'FC_41SolicitudAtencionACliente', 'FC_30SolicitudAtencionACliente',
    'FC_40SolicitudAtencionACliente', 'SolicitudesAtencionACliente']*/
}
const appReducer = combineReducers({
  AppState: AppReducer,
  UbicacionApi: UbicacionApiReducer,
  CopomexApi: CopomexReducer,
  Zonas: ZonaReducer,
  Asociado: AsociadoReducer,
  Unidades: UnidadesReducer,
  Sublocalidad: SublocalidadReducer,
  DiasDeAtencion: DiasDeAtencionReducer,
  FC_01Solicitud: FC01ReducerBeneficiario,
  FC_05Solicitud: FC05ReducerBeneficiario,
  FC_08Solicitud: FC08ReducerBeneficiario,
  FC_09Solicitud: FC09ReducerBeneficiario,
  FC_33Solicitud: FC33ReducerBeneficiario,
  FC_35Solicitud: FC35ReducerBeneficiario,
  FC_34Solicitud: FC34ReducerBeneficiario,
  FC_36Solicitud: FC36ReducerBeneficiario,
  FC_06Solicitud: FC06ReducerBeneficiario,
  FC_31Solicitud: FC31ReducerBeneficiario,
  FC_41Solicitud: FC41ReducerBeneficiario,
  FC_30Solicitud: FC30ReducerBeneficiario,
  FC_40Solicitud: FC40ReducerBeneficiario,
  Solicitudes: SolicitudesReducer,
  Usuario: usuarioReducer,
  Usuarios: usuariosReducer,
  //variables para atncion a cliente
  UsuarioAtencionACLiente: usuarioReducer,
  UsuariosAtencionACLiente: usuariosReducer,
  FC_01SolicitudAtencionACliente: FC01ReducerAtencionACliente,
  FC_05SolicitudAtencionACliente: FC05ReducerAtencionACliente,
  FC_08SolicitudAtencionACliente: FC08ReducerAtencionACliente,
  FC_09SolicitudAtencionACliente: FC09ReducerAtencionACliente,
  FC_33SolicitudAtencionACliente: FC33ReducerAtencionACliente,
  FC_35SolicitudAtencionACliente: FC35ReducerAtencionACliente,
  FC_34SolicitudAtencionACliente: FC34ReducerAtencionACliente,
  FC_36SolicitudAtencionACliente: FC36ReducerAtencionACliente,
  FC_06SolicitudAtencionACliente: FC06ReducerAtencionACliente,
  FC_31SolicitudAtencionACliente: FC31ReducerAtencionACliente,
  FC_41SolicitudAtencionACliente: FC41ReducerAtencionACliente,
  FC_30SolicitudAtencionACliente: FC30ReducerAtencionACliente,
  FC_40SolicitudAtencionACliente: FC40ReducerAtencionACliente,
  AtencionSolicitud: AtencionClientesReducer,
  Calendario: CalendarioReducer,
  Inspectores: InspectorReducer,
  Puestos: PuestoReducer,
  Vehiculos: VehiculoReducer,
  UsuariosAtencionACliente: UsuariosAtencionAClienteReducer,
  CatalogoMagueyApi: CatalogoMagueyReducerUsuarioAgricola,
  GuiaMagueyApi: GuiaMagueyReducerUsuarioAgricola,
  RegistroPredioApi: RegistroPredioReducerUsuarioAgricola,
  ConstanciasApi: ConstanciasReducerUsuarioAgricola,
  DatosPredioApi: DatosPredioReducerUsuarioAgricola,
  DatosMagueyApi: DatosMagueyReducerUsuarioAgricola,
  DescuentoPredio:DescuentoPredioReducerUsuarioAgricola,
  InformacionValidaApi: InformacionValidaReducer,
  Cliente: ClienteReducer,
  ModuloConsulta: ModuloConsultaReducer,
  Instalacion: InstalacionReducer,
  Cuestionario: CuestionarioReducer,
  Caratula: CaratulaReducer,
  BuenasPracticas: BuenasPracticasReducer,
  Testigos: TestigosReducer,
  Responsables: ResponsablesReducer,
  Informe: InformeReducer,
  SeccionCuestionario: SeccionCuestionarioReducer,
  PreguntaInstalacion: PreguntaInstalacionReducer,
  CalificacionPregunta: CalificacionPreguntaReducer,
  DataElementoClienteHistorial: DataElementoClienteHistorialReducer,
  EquipoHistorial: EquipoHistorialReducer,
  TipoEquipo: TipoEquipoReducer,
  Procesos: ProcesoReducer,
  anexo: anexoReducer,
  FotoGaleria: FotoGaleriaReducer,
  Superficie: SuperficieReducer,
  ElementoSeccion: ElementoSeccionReducer,
  ArchivosUnidadInspeccion: ArchivosReducer,
  Cumplimiento: CumplimientoReducer,
  DatosMagueyHistoricoApi: DatosMagueyHistoricoReducerUsuarioAgricola,
  DatosPredioHistoricoApi: DatosPredioHistoricoReducerUsuarioAgricola,
  InformacionValidaApi: InformacionValidaReducer,
  SolicitudesUIF01: SolicitudesUIF01Reducer,
  Fi25Documentos: Fi25DocumentosReducer,
  EstatusSolicitudesUIF01: EstatusSolicitudesUIF01Reducer,
  OficiosBeneficiarioOC: OficiosBeneficiarioOCReducer,
  MesZona: MesZonaReducer,
  AsociadoLocalidad: AsociadoLocalidadReducer,
  CatalogoMagueyNombreCientifico: CatalogoMagueyNombreCientificoReducer,
  ModuloCompras: ModuloComprasReducer,
  ModuloInventario: ModuloInventarioReducer,
  ModuloEntregas: ModuloEntregasReducer,
  GenerarUsuarios: GenerarUsuariosReducer,
  UsuarioDivisionAgricola: UsuarioDivisionAgricolaReducer,
  SolicitudesFC01_OC: SolicitudesFC01_OCReducer,
  DireccionGerente: DireccionGerenteReducer,
  SolicitudesFC09_OC: SolicitudesFC09_OCReducer,
  // GenerarOficios: GenerarOficiosReducer,
  MesZona: MesZonaReducer,
  AsociadoLocalidad: AsociadoLocalidadReducer,
  // InformacionCliente: InformacionClienteReducer,
  CatalogoMagueyNombreCientifico: CatalogoMagueyNombreCientificoReducer,
  Periodos: PeriodosReducer,
  AnalisisFQ: AnalisisFQReducer,
  RebecaUI: RebecaUIReducer,
  DocumentosLote: DocumentosLoteReducer,
  Laboratorio: LaboratorioReducer,
  FoliosUI: FoliosUIReducer,
  Trazabilidad: TrazabilidadReducer,
  //Para developer
  UsuarioDeveloper: UsuarioDeveloperReducer,
  ConstanciasDev: ConstanciasDevReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    localStorage.removeItem('persist:root')
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}



const persistedReducer = persistReducer(persistConfig, rootReducer)
const persistedReducerAtencionACliente = persistReducer(persistConfigAtencionACliente, rootReducer)

export default function generateStore() {
  let store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(thunk)))
  let persistor = persistStore(store)
  return { store, persistor }
}
